import React, { Component } from 'react';
import '../styles/ProjectAssets.scss';
import LightBox from './LightBox';

class ProjectAssets extends Component {
  constructor() {
    super();

    this.state = {
      assetIndex: 0
    }

    this.viewPrevAsset = this.viewPrevAsset.bind(this);
    this.viewNextAsset = this.viewNextAsset.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onArrowKeyDown = this.onArrowKeyDown.bind(this);
  }

  static propTypes = {
    project: React.PropTypes.object.isRequired,
    hasOpenModal: React.PropTypes.bool.isRequired,
    openModal: React.PropTypes.func.isRequired
  };

  viewPrevAsset() {
    const { assets } = this.props.project;
    let index = this.state.assetIndex;
    index--;
    if (index < 0) {
      index = assets.length - 1;
    }
    this.openModal(assets[index], index);
  }

  viewNextAsset() {
    const { assets } = this.props.project;
    let index = this.state.assetIndex;
    index++;
    if (index === assets.length) {
      index = 0;
    }
    this.openModal(assets[index], index);
  }

  openModal(asset, index) {
    this.setState({ assetIndex: index });
    let events = {};
    if (this.props.project.assets.length > 1) {
      events = {
        onPrev: this.viewPrevAsset,
        onNext: this.viewNextAsset
      };
    }
    const modalContent = <LightBox {...asset} {...events} />;
    this.props.openModal(modalContent);
  }

  onArrowKeyDown(e) {
    if (!this.props.hasOpenModal) return;
    if (e.keyCode === 37) { this.viewPrevAsset(this.state.assetIndex); }
    if (e.keyCode === 39) { this.viewNextAsset(this.state.assetIndex); }
  }

  componentWillMount() {
    document.addEventListener('keydown', this.onArrowKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onArrowKeyDown);
  }

  render() {
    const { assets } = this.props.project;
    return (
      <div className="ProjectAssets">
        <div className="row">
          {assets.map((asset, i) => {
            const { grid, thumb } = asset;
            const style = { backgroundImage: `url(${thumb})` };
            return (
              <div className={`asset ${grid}`} key={i}>
                <div className="inner">
                  <div style={style} onClick={() => this.openModal(asset, i)} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ProjectAssets;



// WEBPACK FOOTER //
// ./src/components/ProjectAssets.js